import PoiCardMedia from 'components/cards/poi/PoiCardMedia';
import Link from 'components/links/Link';
import { X } from 'kzv-icons';
import PropTypes from 'prop-types';
import React from 'react';

import IconButton from '../../buttons/IconButton';

function PoiMapCard({ title, images = [], link, location, handleClose }) {
    const hasMedia = images.length > 0;
    return (
        <div className={`relative ${hasMedia ? '' : 'pt-4'}`}>
            <Link to={link} styles="inline-block w-full h-full absolute top-0 left-0" />
            <IconButton
                styles={`top-1 right-1 absolute text-lg z-10 text-white ${
                    hasMedia ? 'focus:text-primary' : 'text-primary'
                } hover:ring-brand hover:ring-2 `}
                size="small"
                onClick={handleClose}
            >
                <X strokeWidth={2} />
            </IconButton>

            {hasMedia && (
                <div className="h-32">
                    <PoiCardMedia images={images} alt={title} className={'rounded-t-xl'} />
                </div>
            )}
            <div className="content px-4 pt-2 pb-4">
                <h4 className="leading-tight font-medium text-brand font-serif">{title}</h4>
                {location && <p className="font-medium text-sm">{location}</p>}
            </div>
        </div>
    );
}

PoiMapCard.propTypes = {
    title: PropTypes.string.isRequired,
    media: PropTypes.array,
    attributes: PropTypes.array,
    link: PropTypes.string.isRequired
};

export default PoiMapCard;
